import { reportError } from './errorTracking';
import * as meetingApi from './meetingApi';
import { getUserFriendlyError } from '../utils/errors';

// Web's implementation of @copilot/ui's MeetingDetailsApi - what the
// shared Meeting Details tabs read and write. One module-level object so
// its identity never changes (a new one would reload every tab).

function downloadBlob(blob, filename) {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename || 'KrishvaQ_Meeting_Summary.pdf';
  try {
    link.click();
  } finally {
    URL.revokeObjectURL(url);
  }
}

export const meetingDetailsApi = {
  async getTranscripts(meetingId, { page, pageSize }) {
    const data = await meetingApi.getMeetingTranscripts(meetingId, { page, pageSize });
    // An older backend answered with a bare array (no paging).
    return Array.isArray(data)
      ? { items: data, total: data.length }
      : { items: data.items, total: data.total };
  },

  getAiResponses: (meetingId) => meetingApi.getMeetingAiResponses(meetingId),

  submitAiFeedback: (responseId, feedback, reason) =>
    meetingApi.submitAiAnswerFeedback(responseId, { feedback, reason }),

  getSummary: (meetingId) => meetingApi.getMeetingSummary(meetingId),

  async exportSummaryPdf(meetingId) {
    try {
      const { blob, filename } = await meetingApi.exportMeetingSummaryPdf(meetingId);
      downloadBlob(blob, filename);
    } catch (err) {
      reportError('meeting_summary_export_pdf', err);
      throw err;
    }
  },

  getActionItems: (meetingId) => meetingApi.getActionItems(meetingId),

  async updateActionItemStatus(itemId, status) {
    try {
      return await meetingApi.updateActionItemStatus(itemId, status);
    } catch (err) {
      reportError('action_item_status_update', err);
      throw err;
    }
  },

  getInsights: (meetingId) => meetingApi.getMeetingInsights(meetingId),

  describeError(error, fallback) {
    return {
      message: getUserFriendlyError(error, fallback),
      notFound: error?.status === 404,
    };
  },
};
